import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomInput } from 'reactstrap';
import { TableLabel } from '../TableLabel';
import { SyntheticEvent } from '../../../types/event.type';
import { useSelectedMembers } from '../../../contexts/SelectedMembers';
import { TableHeaderProps } from './types/type';

export const TableHeader = ({ dropdownListLabels, memberFiltered, allSelected}: TableHeaderProps) => {
  const { t } = useTranslation('tableHeaderTitle');
  const titles = t('title', { returnObjects: true }) as Array<string>;
  const { selectedMembers, addMember, clearMembers } = useSelectedMembers();

  const handleCheckBox = (event: SyntheticEvent) => {
    if (event.target.checked) {
      addMember(memberFiltered as any);
    } else {
      clearMembers();
    }
  };

  return (
    <>
      <tr>
        <th>
          <CustomInput
            className={selectedMembers.length > 0 && selectedMembers.length < memberFiltered.length ? 'arrow-flat' : ''}
            id="select-all-members-rows"
            type="checkbox"
            onChange={(event) => handleCheckBox(event)}
            checked={selectedMembers.length > 0}
            disabled={allSelected}
          />
        </th>
        {titles?.map((title) => (
          <th key={title}>
            <TableLabel title={title} dropdownLabels={dropdownListLabels} />
          </th>
        ))}
      </tr>
    </>
  );
};
